module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/map-cc79891816a57036a2a12b7768660f2f.png";